//
//
//
//
//
//
//
//
//

import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {}
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getStyle(){
      return {"backgroundColor": this.question.backgroundColor || "#FFF7EE", "opacity": this.question.backgroundOpacity / 100 || "1"}
    }
  },
  methods: {
    validate () {
      return true
    }
  }
}
